"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 16 16" id=icon-confirmation-filled-small><path d="M8 0a8 8 0 100 16A8 8 0 008 0zm3.71 6.71l-4 4a1 1 0 01-1.41 0l-2-2a1 1 0 011.41-1.42L7 8.59l3.29-3.29a1 1 0 011.41 1.41h.01z"></path></symbol>';
}